<template>
  <div>
    <b-modal id="modalEditProfilesOfDocuments" ref="modalEditProfilesOfDocuments" :title="$t('Profile of documents')" hide-footer @shown="shown">
      <div v-if="editItem">
        <b-form-group label-align="right" v-if="editItem.profile_id != 0" :label="$t('Profile ID')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input disabled v-model="editItem.profile_id"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.name" aria-describedby="inputFeedbackName" :state="editItem.name.length > 0"/>
          <b-form-invalid-feedback id="inputFeedbackName">
            {{ $t('Enter title') }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Bill')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select :options="bills" v-model="editItem.selectBill"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('TAX invoice')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select :options="TAXinvoice" v-model="editItem.selectTAXinvoice"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('User info sheet')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select :options="userInfoSheet" v-model="editItem.selectUserInfoSheet"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Certificate of completion')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select :options="certificateOfCompletion" v-model="editItem.selectCertificateOfCompletion"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Receipt')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select :options="receipt" v-model="editItem.selectReceipt"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Bill details')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select :options="billDetails" v-model="editItem.selectBillDetails"/>
        </b-form-group>

        <b-row>
          <b-col>
            <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="save">{{ $t('Save')}}</b-button>
          </b-col>
          <b-col sm="1.5">
            <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click.stop="$refs.modalEditProfilesOfDocuments.hide">{{ $t('Cancel') }}</b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    editItem: null
  },
  methods: {
    shown () {
      let editItem = this.editItem
      this.$set(editItem, 'selectBill', 0)
      this.$set(editItem, 'selectTAXinvoice', 0)
      this.$set(editItem, 'selectUserInfoSheet', 0)
      this.$set(editItem, 'selectCertificateOfCompletion', 0)
      this.$set(editItem, 'selectReceipt', 0)
      this.$set(editItem, 'selectBillDetails', 0)
      for (let el of editItem.templates) {
        switch (el.type) {
          case 1:
            editItem.selectBill = el.template_id
            break
          case 2:
            editItem.selectTAXinvoice = el.template_id
            break
          case 3:
            editItem.selectUserInfoSheet = el.template_id
            break
          case 4:
            editItem.selectCertificateOfCompletion = el.template_id
            break
          case 5:
            editItem.selectReceipt = el.template_id
            break
          case 7:
            editItem.selectBillDetails = el.template_id
            break
          default:
            break
        }
      }
    },
    save () {
      if (!this.editItem.name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Full name fields is invalid'), 'Error')
        return
      }

      if (this.editItem.profile_id !== 0) {
        this.editItem.templates = []
      }
      let newEl = {
        type: 0,
        template_id: 0
      }
      if (this.editItem.selectBill) {
        newEl.type = 1
        newEl.template_id = this.editItem.selectBill
        this.editItem.templates.push(newEl)
      }
      if (this.editItem.selectTAXinvoice) {
        newEl.type = 2
        newEl.template_id = this.editItem.selectTAXinvoice
        this.editItem.templates.push(newEl)
      }
      if (this.editItem.selectUserInfoSheet) {
        newEl.type = 3
        newEl.template_id = this.editItem.selectUserInfoSheet
        this.editItem.templates.push(newEl)
      }
      if (this.editItem.selectCertificateOfCompletion) {
        newEl.type = 4
        newEl.template_id = this.editItem.selectCertificateOfCompletion
        this.editItem.templates.push(newEl)
      }
      if (this.editItem.selectReceipt) {
        newEl.type = 5
        newEl.template_id = this.editItem.selectReceipt
        this.editItem.templates.push(newEl)
      }
      if (this.editItem.selectBillDetails) {
        newEl.type = 7
        newEl.template_id = this.editItem.selectBillDetails
        this.editItem.templates.push(newEl)
      }
      let response = this.editItem.profile_id !== 0
        ? this.$store.dispatch('Settings/UPDATE_PROFILES_OF_DOCUMENTS', this.editItem)
        : this.$store.dispatch('Settings/CREATE_PROFILES_OF_DOCUMENTS', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_PROFILES_OF_DOCUMENTS')
          this.$refs.modalEditProfilesOfDocuments.hide()
          this.$root.$emit('makeToasts')
        }
      })
    }
  },
  computed: {
    bills () {
      let options = this.$store.getters['Settings/DOCUMENT_TEMPLATES'].filter((val) => {
        return val.type === 1
      })
      for (let el of options) {
        el.value = el.template_id
        el.text = '(' + el.template_id + ') ' + el.name
      }
      let newEl = {
        value: 0,
        text: this.$t('Template not set')
      }
      options.push(newEl)
      return options
    },
    TAXinvoice () {
      let options = this.$store.getters['Settings/DOCUMENT_TEMPLATES'].filter((val) => {
        return val.type === 2
      })
      for (let el of options) {
        el.value = el.template_id
        el.text = '(' + el.template_id + ') ' + el.name
      }
      let newEl = {
        value: 0,
        text: this.$t('Template not set')
      }
      options.push(newEl)
      return options
    },
    userInfoSheet () {
      let options = this.$store.getters['Settings/DOCUMENT_TEMPLATES'].filter((val) => {
        return val.type === 3
      })
      for (let el of options) {
        el.value = el.template_id
        el.text = '(' + el.template_id + ') ' + el.name
      }
      let newEl = {
        value: 0,
        text: this.$t('Template not set')
      }
      options.push(newEl)
      return options
    },
    certificateOfCompletion () {
      let options = this.$store.getters['Settings/DOCUMENT_TEMPLATES'].filter((val) => {
        return val.type === 4
      })
      for (let el of options) {
        el.value = el.template_id
        el.text = '(' + el.template_id + ') ' + el.name
      }
      let newEl = {
        value: 0,
        text: this.$t('Template not set')
      }
      options.push(newEl)
      return options
    },
    receipt () {
      let options = this.$store.getters['Settings/DOCUMENT_TEMPLATES'].filter((val) => {
        return val.type === 5
      })
      for (let el of options) {
        el.value = el.template_id
        el.text = '(' + el.template_id + ') ' + el.name
      }
      let newEl = {
        value: 0,
        text: this.$t('Template not set')
      }
      options.push(newEl)
      return options
    },
    billDetails () {
      let options = this.$store.getters['Settings/DOCUMENT_TEMPLATES'].filter((val) => {
        return val.type === 7
      })
      for (let el of options) {
        el.value = el.template_id
        el.text = '(' + el.template_id + ') ' + el.name
      }
      let newEl = {
        value: 0,
        text: this.$t('Template not set')
      }
      options.push(newEl)
      return options
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_DOCUMENT_TEMPLATES')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/settings/documents/profilesOfDocuments/editModal.vue